import { useEffect, useRef, useState } from "react";
import { initializeTimer, startCountdown } from "./utils";

/**
 * Custom hook for managing a countdown timer.
 * @param timerKey - Unique identifier for the timer
 * @param initialTime - Optional initial time in seconds (defaults to INITIAL_COUNTDOWN_TIME)
 * @returns Current countdown time in seconds
 */
export function useCountdownTimer(
  timerKey: string,
  initialTime?: number
): number {
  const [countdownTime, setCountdownTime] = useState<number>(() =>
    initializeTimer(timerKey, initialTime)
  );
  const isMountedRef = useRef<boolean>(true);

  useEffect(() => {
    startCountdown(timerKey, time => {
      if (isMountedRef.current) {
        setCountdownTime(time);
      }
    });

    return () => {
      isMountedRef.current = false;
    };
  }, [timerKey]);

  return countdownTime;
}
